(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function() {
    // ── Marquee: clone-to-fill + injected CSS @keyframes with exact px ──
    // CSS animation engine interpolates sub-pixel smoothly — no JS timing drift,
    // no modulo jump, no floating-point accumulation.
    var annBarIndex = 0;
    function initMarquee(bar) {
      var inner   = bar.querySelector('.announcement-bar__inner--marquee');
      var origSet = bar.querySelector('.announcement-bar__set');
      if (!inner || !origSet) return;

      var speedSecs = parseFloat(
        bar.style.getPropertyValue('--announcement-marquee-speed')
      ) || 30;

      // Unique id so multiple bars each get their own @keyframes rule
      var uid = 'ann-scroll-' + (annBarIndex++);
      var styleEl = document.createElement('style');
      styleEl.id = uid;
      document.head.appendChild(styleEl);

      function buildAndMeasure() {
        // Pause & reset so measurement is clean
        inner.style.animation = 'none';
        inner.style.transform = 'translateX(0)';

        // Remove previously cloned sets
        inner.querySelectorAll('.announcement-bar__set--clone').forEach(function(el) {
          el.remove();
        });

        var setWidth = origSet.getBoundingClientRect().width;
        if (setWidth === 0) return;

        // Clone enough sets to fill bar width + one extra so no gap is ever visible
        var needed = Math.ceil((bar.offsetWidth + setWidth) / setWidth);
        for (var i = 0; i < needed; i++) {
          var clone = origSet.cloneNode(true);
          clone.classList.add('announcement-bar__set--clone');
          clone.setAttribute('aria-hidden', 'true');
          inner.appendChild(clone);
        }

        // Inject @keyframes with the exact measured pixel distance.
        // The animation translates exactly one set width, then CSS loops
        // seamlessly back to 0 — the browser's own compositor handles this,
        // no JS frame timing involved at all.
        styleEl.textContent =
          '@keyframes ' + uid + ' {'
          + 'from { transform: translateX(0) }'
          + 'to   { transform: translateX(-' + setWidth + 'px) }'
          + '}';

        inner.style.animation =
          uid + ' ' + speedSecs + 's linear infinite';
      }

      // Hover pause via CSS property
      bar.addEventListener('mouseenter', function() {
        inner.style.animationPlayState = 'paused';
      });
      bar.addEventListener('mouseleave', function() {
        inner.style.animationPlayState = 'running';
      });

      window.addEventListener('resize', buildAndMeasure, { passive: true });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(buildAndMeasure);
      } else {
        buildAndMeasure();
      }
    }

    document.querySelectorAll('[data-announcement-bar]').forEach(initMarquee);

    // Close button
    document.querySelectorAll('[data-announcement-close]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var bar = btn.closest('[data-announcement-bar]');
        if (bar) {
          bar.style.height = bar.offsetHeight + 'px';
          bar.style.transition = 'height 0.3s ease, opacity 0.3s ease';
          bar.style.overflow = 'hidden';
          requestAnimationFrame(function() {
            bar.style.height = '0';
            bar.style.opacity = '0';
          });
          setTimeout(function() { bar.style.display = 'none'; }, 320);
        }
      });
    });

    // Rotating messages
    document.querySelectorAll('[data-announcement-rotate]').forEach(function(container) {
      var messages = container.querySelectorAll('[data-announcement-message]');
      if (messages.length < 2) return;
      var current = 0;
      var interval = parseInt(container.closest('[data-announcement-bar]')
        .style.getPropertyValue('--announcement-rotate-speed')) || 4000;

      setInterval(function() {
        var next = (current + 1) % messages.length;
        messages[current].classList.remove('is-active');
        messages[current].classList.add('is-leaving');
        messages[next].classList.add('is-active');
        var leaving = messages[current];
        setTimeout(function() { leaving.classList.remove('is-leaving'); }, 450);
        current = next;
      }, interval);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    var THRESHOLD = parseInt(drawer.dataset.shipThresholdPaise || '0', 10);
    var LABEL_BELOW = drawer.dataset.shipLabelBelow || 'Add %AWAY% for free shipping';
    var LABEL_DONE  = drawer.dataset.shipLabelDone  || 'FREE SHIPPING UNLOCKED ';
    var overlay = drawer.querySelector('[data-cart-drawer-overlay]');
    var closeBtn = drawer.querySelector('[data-cart-drawer-close]');
    var itemsEl = drawer.querySelector('[data-cart-items]');
    var emptyEl = drawer.querySelector('[data-cart-empty]');
    var footEl = drawer.querySelector('[data-cart-foot]');
    var othWrapEl = drawer.querySelector('[data-cart-oth-wrap]');
    var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    var countEl = drawer.querySelector('[data-cart-count]');
    var shipEl = drawer.querySelector('[data-ship]');
    var shipMsgEl = drawer.querySelector('[data-ship-msg]');
    var shipFillEl = drawer.querySelector('[data-ship-fill]');

    function money(paise) {
      var rupees = paise / 100;
      if (window.Shopify && Shopify.money_format) {
        var formatted = rupees.toFixed(2);
        return Shopify.money_format
          .replace('{{amount}}', formatted)
          .replace('{{amount_no_decimals}}', Math.round(rupees))
          .replace('{{amount_with_comma_separator}}', formatted.replace('.', ','))
          .replace('{{amount_no_decimals_with_comma_separator}}', String(Math.round(rupees)).replace(/(\d)(?=(\d\d)+\d$)/g, '$1,'));
      }
      var rounded = Math.round(rupees);
      return 'Rs. ' + String(rounded).replace(/(\d)(?=(\d\d)+\d$)/g, '$1,');
    }
    function syncHeaderCount(count) {
      document.querySelectorAll('.header__cart-count').forEach(function(el){
        el.textContent = String(count);
        el.style.display = count > 0 ? '' : 'none';
      });
    }
    function renderShip(totalPaise) {
      if (!shipEl) return;
      if (THRESHOLD <= 0 || totalPaise >= THRESHOLD) {
        shipMsgEl.textContent = LABEL_DONE;
        shipFillEl.style.width = '100%';
        shipEl.classList.add('is-unlocked');
      } else {
        var away = THRESHOLD - totalPaise;
        shipMsgEl.textContent = LABEL_BELOW.replace('%AWAY%', money(away));
        shipFillEl.style.width = Math.max(2, (totalPaise / THRESHOLD) * 100) + '%';
        shipEl.classList.remove('is-unlocked');
      }
    }
    function escapeHtml(s){ return String(s||'').replace(/[&<>"]/g, function(c){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'})[c]; }); }
    function escapeAttr(s){ return escapeHtml(s).replace(/'/g,'&#39;'); }

    function renderItems(cart) {
      if (countEl) countEl.textContent = '(' + cart.item_count + ')';
      syncHeaderCount(cart.item_count);
      if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
      renderShip(cart.total_price);
      if (cart.item_count === 0) {
        itemsEl.innerHTML = '';
        emptyEl.hidden = false;
        footEl.hidden = true;
        if (othWrapEl) othWrapEl.hidden = true;
        return;
      }
      emptyEl.hidden = true;
      footEl.hidden = false;
      if (othWrapEl) othWrapEl.hidden = false;
      itemsEl.innerHTML = cart.items.map(function(item){
        var _imgUrl = (item.featured_image && item.featured_image.url) ? item.featured_image.url : item.image;
        var img = _imgUrl
          ? '<img src="' + _imgUrl + (_imgUrl.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="' + escapeHtml(item.product_title) + '" loading="eager" width="80" height="100">'
          : '';
        var variant = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<div class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</div>'
          : '';
        return '<div class="cart-drawer__item" data-key="' + escapeAttr(item.key) + '">'
          + '<a href="' + escapeAttr(item.url) + '" class="cart-drawer__item-img">' + img + '</a>'
          + '<div class="cart-drawer__item-body">'
          +   '<a href="' + escapeAttr(item.url) + '" class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>'
          +   variant
          +   '<div class="cart-drawer__item-row">'
          +     '<div class="cart-drawer__qty">'
          +       '<button type="button" class="cart-drawer__qty-btn" data-qty-dec aria-label="Decrease quantity">-</button>'
          +       '<input type="number" min="0" class="cart-drawer__qty-val" value="' + item.quantity + '" data-qty-val inputmode="numeric" aria-label="Quantity">'
          +       '<button type="button" class="cart-drawer__qty-btn" data-qty-inc aria-label="Increase quantity">+</button>'
          +     '</div>'
          +     '<div class="cart-drawer__item-price">' + money(item.final_line_price) + '</div>'
          +   '</div>'
          +   '<button type="button" class="cart-drawer__item-remove" data-line-remove>Remove</button>'
          + '</div>'
          + '</div>';
      }).join('');
    }
    function refresh() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r){ return r.json(); })
        .then(function(cart){ renderItems(cart); return cart; });
    }

    function open() {
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
      refresh();
    }
    function close() {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
    }
    document.addEventListener('click', function(e){
      if (e.target.closest('[data-cart-drawer-toggle]')) { e.preventDefault(); open(); }
    });
    overlay && overlay.addEventListener('click', close);
    closeBtn && closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close(); });

    itemsEl && itemsEl.addEventListener('click', function(e){
      var item = e.target.closest('.cart-drawer__item');
      if (!item) return;
      var key = item.dataset.key;
      var input = item.querySelector('[data-qty-val]');
      if (e.target.closest('[data-qty-inc]')) updateLine(key, parseInt(input.value || '0', 10) + 1);
      if (e.target.closest('[data-qty-dec]')) updateLine(key, Math.max(0, parseInt(input.value || '0', 10) - 1));
      if (e.target.closest('[data-line-remove]')) updateLine(key, 0);
    });
    itemsEl && itemsEl.addEventListener('change', function(e){
      var input = e.target.closest('[data-qty-val]');
      if (!input) return;
      var item = e.target.closest('.cart-drawer__item');
      if (!item) return;
      updateLine(item.dataset.key, Math.max(0, parseInt(input.value || '0', 10)));
    });
    function updateLine(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function(r){ return r.json(); }).then(renderItems);
    }
    document.addEventListener('submit', function(e){
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var fd = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      }).then(function(r){ if (!r.ok) return r.json().then(function(err){ throw err; }); return r.json(); })
        .then(function(){ return refresh(); })
        .then(function(){ open(); })
        .catch(function(err){ if (err && err.description) alert(err.description); });
    });
    refresh();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var isSmart = header.classList.contains('site-header--smart');
    var isTransparent = header.classList.contains('site-header--transparent');
    var isSticky = header.classList.contains('site-header--sticky');

    if (!isSmart && !isTransparent) return;

    var lastScrollY = window.scrollY;
    var scrollThreshold = 80;
    var ticking = false;

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    function update() {
      var scrollY = window.scrollY;

      // Transparent: reveal background once scrolled past a few pixels
      // Only applies when header is sticky — if sticky mode is none, header scrolls away anyway
      if (isTransparent && (isSticky || isSmart)) {
        if (scrollY > 10) {
          header.classList.add('is-scrolled');
        } else {
          header.classList.remove('is-scrolled');
        }
      }

      // Smart: hide on scroll down, reveal on scroll up
      if (isSmart) {
        if (scrollY > lastScrollY && scrollY > scrollThreshold) {
          header.classList.add('is-hidden');
        } else if (scrollY < lastScrollY) {
          header.classList.remove('is-hidden');
        }
      }

      lastScrollY = scrollY;
      ticking = false;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-drawer"]) return;
  try {
    
  (function() {
    var drawer  = document.querySelector('[data-search-drawer]');
    var input   = document.getElementById('search-drawer-input');
    var results = document.getElementById('search-drawer-results');
    var links   = document.getElementById('search-drawer-links');
    var clearBtn = document.getElementById('search-drawer-clear');
    if (!drawer) return;

    var debounceTimer = null;
    var currentQuery  = '';

    /* ── Format money ──
       Hashway storefront is INR-only. Hardcoded here because this code
       lives inside {% javascript %}, which does NOT process Liquid —
       so {{ shop.currency }} would be served as literal text and
       break the compiled bundle silently. */
    function formatMoney(val) {
      if (val == null) return '';
      // Predictive Search API returns prices as decimal strings
      // (e.g. "2499.00") already in the store's currency unit.
      var amount = parseFloat(val);
      if (isNaN(amount)) return '';
      try {
        return new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: 'INR',
          maximumFractionDigits: amount % 1 === 0 ? 0 : 2,
        }).format(amount);
      } catch (e) {
        // Manual fallback for ancient browsers: Rs. 2,499
        var rounded = Math.round(amount);
        var grouped = String(rounded).replace(/(\d)(?=(\d\d)+\d$)/g, '$1,');
        return 'Rs. ' + grouped;
      }
    }

    /* ── Highlight matching query in text ── */
    function highlight(text, query) {
      if (!query) return text;
      var escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return text.replace(new RegExp('(' + escaped + ')', 'gi'), '<mark class="search-drawer__highlight">$1</mark>');
    }

    var COLOR_MAP = {
      black:'#111111', white:'#ffffff', red:'#e53e3e', blue:'#3182ce',
      navy:'#1a3a5c', green:'#38a169', olive:'#6b7c3a', yellow:'#ecc94b',
      orange:'#ed8936', pink:'#ed64a6', purple:'#805ad5', violet:'#805ad5',
      grey:'#9e9e9e', gray:'#9e9e9e', brown:'#8b5e3c', tan:'#c8a882',
      cream:'#fffdd0', ivory:'#fffff0', beige:'#d4c5a9', sand:'#c2b280',
      khaki:'#c3b091', teal:'#319795', cyan:'#00bcd4', lime:'#9acd32',
      maroon:'#800000', burgundy:'#800020', wine:'#722f37', rust:'#b7410e',
      camel:'#c19a6b', stone:'#8e8e78', slate:'#708090', silver:'#c0c0c0',
      gold:'#ffd700', copper:'#b87333', coral:'#ff7f7f', mint:'#98ff98',
      lavender:'#e6e6fa', lilac:'#c8a2c8', rose:'#ff007f', mauve:'#e0b0ff',
      charcoal:'#36454f', ecru:'#c2b280', denim:'#1560bd', indigo:'#4b0082',
      forest:'#228b22', sage:'#b2ac88', taupe:'#483c32', blush:'#ff6e7f',
      cobalt:'#0047ab', scarlet:'#ff2400', chocolate:'#7b3f00', espresso:'#3c1a0d',
      plum:'#8e4585', magenta:'#ff00ff', fuchsia:'#ff00ff', mustard:'#ffdb58',
      mocha:'#967259', nude:'#e8cbb0', multi:'linear-gradient(135deg,#e53e3e,#3182ce,#38a169)'
    };

    function colorFromName(name) {
      if (!name) return null;
      var lower = name.toLowerCase().trim();
      // exact match first
      if (COLOR_MAP[lower]) return COLOR_MAP[lower];
      // match first word (e.g. "Forest Green" → "forest")
      var first = lower.split(/[\s\/\-_]+/)[0];
      if (COLOR_MAP[first]) return COLOR_MAP[first];
      // match any word in the name
      var words = lower.split(/[\s\/\-_]+/);
      for (var i = 0; i < words.length; i++) {
        if (COLOR_MAP[words[i]]) return COLOR_MAP[words[i]];
      }
      return null;
    }

    function isLight(hex) {
      if (!hex || hex.indexOf('gradient') !== -1) return false;
      var c = hex.replace('#','');
      if (c.length === 3) c = c[0]+c[0]+c[1]+c[1]+c[2]+c[2];
      var r = parseInt(c.substr(0,2),16), g = parseInt(c.substr(2,2),16), b = parseInt(c.substr(4,2),16);
      return (r*299 + g*587 + b*114) / 1000 > 210;
    }

    function buildSwatchesHtml(product) {
      var swatches = product._swatches;
      if (!swatches || !swatches.length) return '';

      var MAX_SWATCHES = parseInt(drawer.getAttribute('data-swatch-max')) || 6;
      var shown = swatches.slice(0, MAX_SWATCHES);
      var extra = swatches.length - shown.length;

      var html = '<div class="search-drawer__result-swatches">';
      shown.forEach(function(s) {
        var imgAttr = s.img ? ' data-img="' + s.img + '"' : '';
        if (s.i) {
          html += '<span class="search-drawer__swatch"' + imgAttr + ' style="background-image:url(' + s.i + ');background-size:cover;" title="' + s.v + '"></span>';
        } else if (s.c) {
          var lightClass = isLight(s.c) ? ' search-drawer__swatch--light' : '';
          html += '<span class="search-drawer__swatch' + lightClass + '"' + imgAttr + ' style="background:' + s.c + ';" title="' + s.v + '"></span>';
        } else {
          var fallback = colorFromName(s.v);
          if (fallback) {
            var lightClass2 = isLight(fallback) ? ' search-drawer__swatch--light' : '';
            html += '<span class="search-drawer__swatch' + lightClass2 + '"' + imgAttr + ' style="background:' + fallback + ';" title="' + s.v + '"></span>';
          }
        }
      });
      if (extra > 0) {
        html += '<span class="search-drawer__swatch-more">+' + extra + '</span>';
      }
      html += '</div>';
      return html;
    }

    /* ── Render results ── */
    function renderResults(products, query, collections) {
      if (!results) return;
      results.innerHTML = '';
      var hasProducts = products && products.length > 0;
      var hasCollections = collections && collections.length > 0;
      if (!hasProducts && !hasCollections) {
        results.innerHTML = '<p class="search-drawer__no-results">No results for \u201c' + query + '\u201d</p>';
        return;
      }
      /* Collections first */
      if (hasCollections) {
        var colLabel = document.createElement('p');
        colLabel.className = 'search-drawer__results-label';
        colLabel.textContent = 'Collections';
        results.appendChild(colLabel);
        collections.forEach(function(c) {
          var a = document.createElement('a');
          a.className = 'search-drawer__result-item search-drawer__result-item--collection';
          a.href = c.url;
          var imgHtml = c.featured_image && c.featured_image.url
            ? '<img class="search-drawer__result-img" src="' + c.featured_image.url + '&width=160" alt="' + (c.title || '') + '" width="80" height="80" loading="lazy" style="opacity:0;transition:opacity 0.3s ease;" onload="this.style.opacity=1" onerror="this.style.opacity=1">'
            : '<div class="search-drawer__result-img-placeholder"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" opacity=".3"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="3" x2="9" y2="21"/></svg></div>';
          a.innerHTML = imgHtml +
            '<div class="search-drawer__result-info">' +
              '<div class="search-drawer__result-title-row">' +
                '<div class="search-drawer__result-title">' + highlight(c.title, query) + '</div>' +
              '</div>' +
              '<div class="search-drawer__result-meta">Collection</div>' +
            '</div>';
          results.appendChild(a);
        });
      }
      if (!hasProducts) {
        var footerNoProducts = document.createElement('div');
        footerNoProducts.className = 'search-drawer__results-footer';
        footerNoProducts.innerHTML = '<a href="/search?q=' + encodeURIComponent(query) + '">' + (drawer.getAttribute('data-viewall-text') || 'View all results') + '</a>';
        results.appendChild(footerNoProducts);
        return;
      }
      var label = document.createElement('p');
      label.className = 'search-drawer__results-label';
      label.textContent = drawer.getAttribute('data-label-text') || 'Products';
      results.appendChild(label);

      products.forEach(function(p) {
        var a = document.createElement('a');
        a.className = 'search-drawer__result-item';
        a.href = p.url;

        var imgHtml = p.featured_image && p.featured_image.url
          ? '<img class="search-drawer__result-img" src="' + p.featured_image.url + '&width=160" alt="' + (p.featured_image.alt || p.title) + '" width="80" height="80" loading="lazy" style="opacity:0;transition:opacity 0.3s ease;" onload="this.style.opacity=1" onerror="this.style.opacity=1">'
          : '<div class="search-drawer__result-img-placeholder"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" opacity=".3"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21,15 16,10 5,21"/></svg></div>';

        var price = '';
        if (p.price_min != null) {
          price = formatMoney(p.price_min);
          if (p.price_max && p.price_max !== p.price_min) {
            price += ' \u2013 ' + formatMoney(p.price_max);
          }
        }

        var swatchesHtml = buildSwatchesHtml(p);

        a.innerHTML = imgHtml +
          '<div class="search-drawer__result-info">' +
            '<div class="search-drawer__result-title-row">' +
              '<div class="search-drawer__result-title">' + highlight(p.title, query) + '</div>' +
              (price ? '<div class="search-drawer__result-price">' + price + '</div>' : '') +
            '</div>' +
            swatchesHtml +
          '</div>';
        results.appendChild(a);
      });

      /* View all link */
      var footer = document.createElement('div');
      footer.className = 'search-drawer__results-footer';
      footer.innerHTML = '<a href="/search?type=product&q=' + encodeURIComponent(query) + '">' + (drawer.getAttribute('data-viewall-text') || 'View all results') + '</a>';
      results.appendChild(footer);
    }

    /* ── Fetch from Shopify Predictive Search API ── */
    function fetchResults(query) {
      if (!query || query.length < 1) {
        results.innerHTML = '';
        if (links) links.classList.remove('is-hidden');
        return;
      }
      if (links) links.classList.add('is-hidden');
      results.innerHTML = '<div class="search-drawer__spinner"></div>';

      var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product,collection&resources[limit]=8&resources[options][prefix]=last';

      fetch(url, { headers: { 'Content-Type': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = data.resources && data.resources.results && data.resources.results.products
            ? data.resources.results.products : [];
          var collections = data.resources && data.resources.results && data.resources.results.collections
            ? data.resources.results.collections : [];
          if (!products.length) { renderResults(products, query, collections); return; }

          /* Fetch Liquid-rendered swatch data in parallel (only way to access native Shopify swatch metafields) */
          var handleFetches = products.map(function(p) {
            var handle = p.url && p.url.split('/products/')[1]
              ? p.url.split('/products/')[1].split('?')[0].split('#')[0]
              : null;
            if (!handle) return Promise.resolve(null);
            return fetch('/products/' + handle + '?view=search-swatches')
              .then(function(r) { return r.text(); })
              .then(function(text) {
                try { return JSON.parse(text.trim()); }
                catch(e) { return null; }
              })
              .catch(function() { return null; });
          });

          Promise.all(handleFetches).then(function(swatchData) {
            swatchData.forEach(function(data, i) {
              if (Array.isArray(data) && data.length) products[i]._swatches = data;
            });
            /* rebuild-tag: 1779533083 */
            renderResults(products, query, collections);
          });
        })
        .catch(function() {
          results.innerHTML = '<p class="search-drawer__no-results">Something went wrong. Please try again.</p>';
        });
    }

    /* ── Swatch hover: swap product image ── */
    if (results) {
      results.addEventListener('mouseover', function(e) {
        var swatch = e.target.closest('.search-drawer__swatch');
        if (!swatch) return;
        var img = swatch.closest('.search-drawer__result-item') && swatch.closest('.search-drawer__result-item').querySelector('.search-drawer__result-img');
        if (!img || !swatch.dataset.img) return;
        if (!img.dataset.original) img.dataset.original = img.src;
        img.src = swatch.dataset.img;
      });
      results.addEventListener('mouseout', function(e) {
        var swatch = e.target.closest('.search-drawer__swatch');
        if (!swatch) return;
        var img = swatch.closest('.search-drawer__result-item') && swatch.closest('.search-drawer__result-item').querySelector('.search-drawer__result-img');
        if (!img || !img.dataset.original) return;
        img.src = img.dataset.original;
      });
    }

    /* ── Input handler with debounce ── */
    if (input) {
      input.addEventListener('input', function() {
        var q = input.value.trim();
        currentQuery = q;
        clearTimeout(debounceTimer);
        if (q.length < 1) {
          results.innerHTML = '';
          if (links) links.classList.remove('is-hidden');
          return;
        }
        if (links) links.classList.add('is-hidden');
        debounceTimer = setTimeout(function() { fetchResults(q); }, 200);
      });
    }

    /* ── Clear / close button ── */
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        if (input.value.trim().length > 0) {
          input.value = '';
          results.innerHTML = '';
          if (links) links.classList.remove('is-hidden');
          input.focus();
        } else {
          closeDrawer();
        }
      });
    }

    /* ── Open / close ── */
    function openDrawer() {
      drawer.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      document.body.classList.add('drawer-is-open');
      requestAnimationFrame(function() {
        drawer.classList.add('is-open');
        var speed = parseInt(getComputedStyle(drawer).getPropertyValue('--sd-speed')) || 350;
        setTimeout(function(){ if (input) input.focus(); }, speed);
      });
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.body.classList.remove('drawer-is-open');
    }

    document.addEventListener('click', function(e) {
      if (e.target.closest('.header__search')) {
        if (drawer.classList.contains('is-open')) {
          closeDrawer();
        } else {
          openDrawer();
        }
      }
    });

    drawer.querySelector('[data-search-drawer-overlay]').addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    /* ── Shopify customizer: open drawer when section is selected ── */
    document.addEventListener('shopify:section:select', function(e) {
      if (e.detail.sectionId === drawer.closest('.shopify-section').id.replace('shopify-section-', '')) {
        openDrawer();
      }
    });
    document.addEventListener('shopify:section:deselect', function(e) {
      if (e.detail.sectionId === drawer.closest('.shopify-section').id.replace('shopify-section-', '')) {
        closeDrawer();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
